import { RpcService } from 'rpc';

export interface Announcements {
	id: number;
	title: string;
	body: string;
	session_id: number;
	author_id: string;
	status: string;
	updated: string;
	pubdate: string;
	created: string;
	published: string;
}

export declare interface IAnnouncementsService extends RpcService {
	announcements(param: { session_id?: number; select?: Record<string, unknown> }): Promise<Announcements[]>;
}

export const svc: IAnnouncementsService = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/@@announcements.rpc`,

	services: {
		announcements: {
			parameters: [
				{
					name: 'session_id',
					type: 'integer',
					optional: true
				},
				{
					name: 'select',
					type: 'object',
					optional: true
				}
			]
		}
	}
}) as IAnnouncementsService;

export default svc;
